export const WALLBOARD_JWT_KEY = 'wallboard_jwt'

export const COMPLETION_STATUS = {
  complete: 'Complete',
  missed: 'Missed',
  skipped: 'Skipped',
  upcoming: 'Upcoming',
}
